module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "top-button is-left"
  }, [_c('div', {
    staticClass: "tags-breadcrumb"
  }, [_c('i', {
    staticClass: "icon-navicon tag-collapse",
    class: [{
      'tag-collapse_right': _vm.isCollapse
    }],
    on: {
      "click": _vm.showCollapse
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "top-title"
  }, [_c('topMenu')], 1), _vm._v(" "), _c('h1', {
    staticClass: "top-title"
  }, [_vm._v(_vm._s(_vm.userInfo.companyName))]), _vm._v(" "), _c('div', {
    staticClass: "top-button is-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "打印助手V2.0",
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "top-item"
  }, [_c('a', {
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "href": "../static/PrinterHelper.zip"
    }
  }, [_vm._v("打印助手")])])]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "主题色",
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "top-item"
  }, [_c('top-theme')], 1)]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "锁屏",
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "top-item"
  }, [_c('top-lock')], 1)]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.isFullScren ? '退出全屏' : '全屏',
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "top-item"
  }, [_c('i', {
    class: _vm.isFullScren ? 'icon-tuichuquanping' : 'icon-quanping',
    on: {
      "click": _vm.handleScreen
    }
  })])]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "用户头像",
      "placement": "bottom"
    }
  }, [_c('img', {
    staticClass: "top-userImg",
    attrs: {
      "src": _vm.userInfo.avatar
    }
  })]), _vm._v(" "), _c('el-dropdown', [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n        " + _vm._s(_vm.userInfo.userName) + "\n        "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.toPersonal.apply(null, arguments)
      }
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.showVerDetail.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.sysVer))]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.downUm.apply(null, arguments)
      }
    }
  }, [_vm._v("帮助")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出系统")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "版本更新详情",
      "visible": _vm.verDetailVisible,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.verDetailVisible = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "data": _vm.tableData,
      "highlight-current-row": "",
      "border": "",
      "span-method": _vm.objectSpanMethod
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "版本",
      "prop": "version",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日期",
      "prop": "updateTime",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(new Date(scope.row.updateTime).toLocaleDateString()) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "prop": "updateType",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块",
      "prop": "menu",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "内容",
      "prop": "log"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开发者",
      "prop": "userName",
      "width": "100"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4fcd6a65","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/index/top/index.vue
// module id = Y5Qi
// module chunks = 5